import { render, staticRenderFns } from "./InvoiceSend.vue?vue&type=template&id=c2ced994&scoped=true&"
import script from "./InvoiceSend.vue?vue&type=script&lang=js&"
export * from "./InvoiceSend.vue?vue&type=script&lang=js&"
import style1 from "./InvoiceSend.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ced994",
  null
  
)

export default component.exports